import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../shared/appointment-ended-message/appointment-ended-message';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { RunVerificationButton } from '../shared/run-verification-button';
import { BoldText } from '../styles';

const SelfPayStatusDialog: FC = () => {
  const { opened, onClose, isLoading, patientInfo, selectedIvSummary, appointment } = usePatientIvStatusDialog();

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Self Pay"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateSubmitted && (
            <>&nbsp;- {moment.utc(selectedIvSummary.dateSubmitted).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '30px 0 20px 0', display: 'block' }}>
        This patient will be paying out of pocket and will not be utilizing insurance.
      </DialogSubTitle>
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <RunVerificationButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(SelfPayStatusDialog);
